function setAuthority() {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return this;
}

const AuthConfiguration = {
  clientId: import.meta.env.VITE_CLIENTID
    ? import.meta.env.VITE_CLIENTID
    : 'local-revers.io',
  authority: 'http://localhost:5000',
  scope: 'openid email api',
  setAuthority,
};

export default AuthConfiguration;
